import { CheckIcon } from "@chakra-ui/icons";
import {
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/input";
import React from "react";
import {
  BaseFieldProps,
  FieldWrapper,
} from "../fields/FieldWrapper/FieldWrapper";

interface DateFieldProps extends BaseFieldProps {
  isValid?: boolean;
  dateOnly?: boolean;
}

export const DateField = ({
  name,
  label,
  id,
  helperText,
  isValid,
  infoText,
  isRequired,
  dateOnly = false,
  ...inputProps
}: DateFieldProps & InputProps) => {
  const formatISODate = (isoDate: string): string => {
    // Check if it's already in YYYY-MM-DD format (timezone-agnostic)
    if (/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) {
      return isoDate;
    }
    // Otherwise parse and format (for backward compatibility)
    const date = new Date(isoDate);
    if (!isNaN(date.getTime())) {
      return date.toISOString().split("T")[0];
    }
    return "";
  };

  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      helperText={helperText}
      infoText={infoText}
      isRequired={isRequired}
    >
      {({ field, form }) => {
        return (
          <InputGroup backgroundColor="#fff" shadow="sm">
            <Input
              {...field}
              value={field.value == null ? "" : formatISODate(field.value)}
              {...inputProps}
              type="date"
              onChange={(e) => {
                const value = e.target.value;
                form.setFieldValue(
                  name,
                  value
                    ? dateOnly
                      ? value // e.g., "2025-04-17"
                      : new Date(value).toISOString()
                    : ""
                );
              }}
            />
            {isValid && (
              <InputRightElement children={<CheckIcon color="green.400" />} />
            )}
          </InputGroup>
        );
      }}
    </FieldWrapper>
  );
};
